import { render, staticRenderFns } from "./Events2.vue?vue&type=template&id=890cde98"
import script from "./Events2.vue?vue&type=script&lang=js"
export * from "./Events2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports